const siteOptionData = [
    {
      id: 1,
      siteName: "Strong Volt Vpn Apps",
      image:
        "https://i.ibb.co/67rCfs8p/favicon.png",
      description: "Experience a secure and reliable VPN service with enhanced privacy and performance.",
      siteLink: "https://mtk-genuine.com/"
    }
  ];
  export default siteOptionData;
